const s = {
    currencySelector: '[data-currency-selector]',
    trigger: '[data-currency-selector-trigger]',
    dropdownItem: '[data-currency-selector-dropdown-item]',
  },
  d = {activeClass: 'active'};
function u(i) {
  const n = [...i.querySelectorAll(s.currencySelector)];
  if (!n) return;
  const o = (e) => {
      e.querySelectorAll('template[data-currency-flag]').forEach((template) => {
        template.replaceWith(template.content.cloneNode(true));
      });
      const r = e.classList.contains(d.activeClass) ? 'remove' : 'add';
      e.classList[r](d.activeClass);
    },
    l = (e, r) => {
      const c = r.dataset.currentCurrency,
        t = e.dataset.currency;
      if (c === t) r.classList.remove(d.activeClass);
      else {
        const a = new URL(window.location);
        a.searchParams.set('currency', t), (window.location.href = a.href);
      }
    };
  n.forEach((e) => {
    const r = e.querySelector(s.trigger),
      c = [...e.querySelectorAll(s.dropdownItem)];
    r.addEventListener('click', () => {
      o(e);
    }),
      c.forEach((t) => {
        t.addEventListener('click', () => {
          l(t, e);
        });
      });
  });
}
export {u as i};
